
import Popular from './components/popular';
 import Vigge from './components/vigge';
//import Category from './components/category';

import React from 'react';

function Home() {
  return (
    <div>
     
     <Vigge />
      <Popular />
    
    </div>
  )
}

export default Home;
